
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';

interface AcceptOffersFieldProps {
  form: any;
}

const AcceptOffersField: React.FC<AcceptOffersFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="acceptOffers"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4 bg-gradient-to-r from-indigo-50 to-purple-50">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel className="text-sm font-medium">
              Accepter les offres par email *
            </FormLabel>
            <FormDescription>
              Je confirme que je souhaite recevoir les offres d'annonces publicitaires par email.
            </FormDescription>
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default AcceptOffersField;
